












import { defineComponent, computed } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import BrandImage from '~/components/molecules/Product/Brand/BrandImage/BrandImage.vue';
import Link from '~/components/atoms/Link/Link.vue';
import { LinkType } from '~/types/components/Link/LinkType';
import type { BrandsType } from '~/constants/brands';
import { useBrandPage } from '~/composables';

export default defineComponent({
  name: 'BrandImageLink',
  components: {
    BrandImage,
    Link,
  },
  props: {
    brand: {
      type: Object as PropType<BrandsType>,
      required: true,
    },
  },
  setup(props) {
    const { getBrandPageUrl } = useBrandPage();
    const brandPage = computed(() => props.brand?.name ? getBrandPageUrl(props.brand?.name) : '');
    const componentTag = computed(() => brandPage.value ? 'Link' : 'div');
    const linkProps = {
      url: brandPage.value,
      type: LinkType.NoStyle,
    };

    const componentProperties = computed(() => componentTag.value === 'Link' ? linkProps : {});

    return {
      componentTag,
      componentProperties,
    };
  },
});
